import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient, ApiResponseError } from "~/utils";

import {
  ApiManagersSkillEvaluationTermResultPointsIndexResponseType,
  ApiManagersSkillEvaluationTermResultPointsIndexRequestType,
} from "~/domains";

type RequestDataType = {
  params?: ApiManagersSkillEvaluationTermResultPointsIndexRequestType;
  id: string;
};

const request = async ({
  params,
  id,
}: RequestDataType): Promise<ApiManagersSkillEvaluationTermResultPointsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersSkillEvaluationTermResultPointsIndexResponseType>(
      `/api/managers/skill_evaluation_terms/${id}/result_points`,
      params,
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  id: string;
  params?: ApiManagersSkillEvaluationTermResultPointsIndexRequestType;
  config?: QueryConfigType<QueryFnType>;
};

export const useApisManagersSkillEvaluationTermsResultPointsIndex = ({
  id,
  params,
  config = {},
}: PropsType): UseQueryResult<ApiManagersSkillEvaluationTermResultPointsIndexResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisManagersSkillEvaluationTermsResultPointsIndex", id, params],
    queryFn: () => request({ id, params }),
    useErrorBoundary: (error) => {
      return error instanceof ApiResponseError && error.status >= 500;
    },
  });
};
